/** * * Asynchronously loads the component for
DigitalSecuritySelection
* */ import { lazyLoad } from "utils/loadable";
export const DigitalSecuritySelection = lazyLoad(
  () => import("./index"),
  (module) => module.DigitalSecuritySelection
);
